module.exports = __webpack_public_path__ + "static/amy-maxwell-new-ca499893d9ef518046032f25be0ca883.png";